module.exports = __webpack_public_path__ + "static/bsas009-7d156d85786d07cc4986bab6293b921f.jpg";